var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomerForm',{attrs:{"customer":_vm.customer,"formType":_vm.type,"buttonLoading":_vm.buttonLoading,"overlay":_vm.overlay},on:{"saveCustomer":_vm.updateCustomer}})}
var staticRenderFns = []

export { render, staticRenderFns }